(function () {
    // Variables set here for global access.
    var allButtons = [];
    var bypass = false;
    var lvlOneLinks = [];
    var classes = {
        active: 'active',
        selectors: {
            button: 'button.qld__main-nav__btn',
            lvlOneNavItem: '.qld__main-nav__item--lvl-one',
            lvlOneNavTitle: '.qld__main-nav__item-title',
            lvlOneNavLink: '.qld__main-nav__item-toggle-text',
            megaMenu: '.qld__main-nav--mega',
            subMenu: '.qld__main-nav__menu-sub',
            subMenuInner: '.qld__main-nav__menu-sub-inner'
        }
    };
    var actions = {
        open: 'open',
        close: 'close',
        keys: [
            'Enter',
            'Space'
        ]
    };
    var timing = 600;

    /**
     * The mega menu module
     * 
     * @module megaMenu
     */
    var megaMenu = {
        /**
         * Initialise the Performance mega menu.
         * 
         * @memberof module:megaMenu
         * 
         * @return {void}
         */
        'init': function () {
            // Identify all Buttons.
            allButtons = Array.from(document.querySelectorAll(classes.selectors.button));
            lvlOneLinks =  Array.from(
                document.querySelectorAll(`${classes.selectors.lvlOneNavItem} > ${classes.selectors.lvlOneNavTitle} > ${classes.selectors.lvlOneNavLink}`)
            );

            // Bind the event handlers to all buttons.
            if (allButtons.length > 0) {
                bindHandlers(allButtons);
            }

            // For keyboard navigation
            if (lvlOneLinks.length > 0) {
                lvlOneLinks.forEach(el => {
                    el.addEventListener('focusin', () => {
                        reset();
                    });

                    el.addEventListener('mouseover', () => {
                        reset();
                    });
                });
            }
        },
    };

    /**
     * Bind the event handlers to the relevant elements.
     * 
     * @instance
     * @private
     * 
     * @return {void}
     */
    var bindHandlers = () => {
        allButtons.forEach(button => {
            button.addEventListener('click', () => {
                if (window.innerWidth < 992) {
                    bypass = false;
                    toggle(button);
                }
            });

            button.addEventListener('keyup', e => {
                if (window.innerWidth > 992 &&
                   actions.keys.includes(e.code)
                ) {
                    bypass = true;
                    toggle(button);
                }
            });
        });
    };

    /**
     * Toggle the submenu.
     * 
     * @param {HTMLElement} button 
     * 
     * @return {void}
     */
    var toggle = (button) => {
        var subMenu = document.querySelector(`#${button.getAttribute('aria-controls')}`);

        // Toggle the classes and menu items according to the classlist.
        if (subMenu instanceof HTMLElement) {
            if (subMenu.classList.contains(classes.active)) {
                button.classList.remove(classes.active);

                animateHeight(button, subMenu, actions.close);
            } else {
                subMenu.classList.add(classes.active);
                button.classList.add(classes.active);

                animateHeight(button, subMenu, actions.open);
            }
        }
    };

    /**
     * Animate the height of the inner submenu.
     * 
     * @param {HTMLElement} button
     * @param {HTMLElement} subMenu
     * @param {string} action
     * 
     * @return {void}
     */
    var animateHeight = (button, subMenu, action) => {
        var inner = subMenu.querySelector(classes.selectors.subMenuInner);

        // If we have an inner sub menu, we want to identify the action,
        // and toggle the height of the collapsible menu items accordingly.
        // The bypass variable is used for ignoring/respecting the timing of
        // the below operations (animated vs instant toggling).
        if (inner instanceof HTMLElement) {
            var height = inner.scrollHeight;
            timing = !bypass ? 600 : 0;

            switch (action) {
                case actions.open:
                    inner.style.height = '0px';

                    setTimeout(() => {
                        inner.style.height = `${height}px`;
                    }, 100);

                    setTimeout(() => {
                        inner.style.height = 'auto';
                      }, timing);

                      setAccessibilityProps(button, action);
                    break;
                case actions.close:
                    inner.style.height = `${height}px`;

                    setTimeout(() => {
                        inner.style.height = '0px';
                    }, 100);

                    setTimeout(() => {
                        subMenu.classList.remove(classes.active);
                        inner.removeAttribute('style');
                    }, timing);

                    setAccessibilityProps(button, action);
                    break;
                default:
                    console.warn('Invalid submenu action provided in animateHeight function.')
                    break;
            }
        }
    };

    /**
     * Set accessibility properties based off the action.
     * 
     * @param {HTMLElement} button
     * @param {string} action 
     * 
     * @return {void}
     */
    var setAccessibilityProps = (button, action) => {
        switch (action) {
            case actions.open:
                button.setAttribute('aria-expanded', true);

                break;
            case actions.close:
                button.setAttribute('aria-expanded', false);

                break;
            default:
                break;
        }
    };

    /**
     * Reset the megamenu by triggering the toggle on active menus
     * via the button. We want the reset to be instantaneous, so we
     * set bypass to true to ensure this is the case.
     * 
     * @return {void}
     */
    var reset = () => {
        var allActiveButtons = document.querySelectorAll(`${classes.selectors.button}[aria-expanded="true"]`);
        var inners = Array.from(document.querySelectorAll(classes.selectors.subMenuInner));
        bypass = true;

        // Toggling all active buttons.
        if (allActiveButtons.length > 0) {
            allActiveButtons.forEach((btn) => {
                toggle(btn);
            });
        }

        // Ensure we remove the height: 0px; from each of the 
        // previously active submenus.
        if (inners.length > 0) {
            setTimeout(() => {                
                inners.forEach(el => {
                    el.removeAttribute('style');
                });
            }, 200);
        }

        bypass = false;
    };

    // On page load, identify if we're on the performance site. If so, init the megamenu.
    window.addEventListener('DOMContentLoaded', function () {
        var isPerformance = document.querySelector('body.dcssds-performance') ? true : false;

        if (isPerformance) {
            // Reset megamenu when resizing into desktop
            window.addEventListener('resize', () => {
                if (this.window.innerWidth > 992) {
                    reset();
                }
            });

            // Reset megamenu when escape key pressed
            window.addEventListener('keyup', e => {
                if (e.code == 'Escape') {
                    reset();
                }
            });

            megaMenu.init();
        }
    });

}());
